module.exports = __webpack_public_path__ + "static/media/dot_009AEE.f4be46e1.svg";